import { type NodeViewProps, NodeViewWrapper } from '@tiptap/react';
import { Loader2 } from 'lucide-react';

export function ImageNodeView({ node, updateAttributes }: NodeViewProps) {
  const { src, alt, title, isLoading } = node.attrs;

  return (
    <NodeViewWrapper className="image-wrapper">
      <div className="relative inline-block my-4">
        <img
          src={src || '/placeholder.svg'}
          alt={alt}
          title={title}
          className={`max-w-full rounded-md ${isLoading ? 'brightness-50' : ''}`}
        />
        {isLoading && (
          <div className="absolute top-2 rounded-full right-2 bg-black/30 p-1">
            <Loader2 className="h-4 w-4 text-white animate-spin" />
          </div>
        )}
      </div>
    </NodeViewWrapper>
  );
}
